import React from "react";

export default function MalkiersCrown() {
  return (
    <>
      <h3>Malkier's Crown is a song from Lan's retrospective about the King and Queen of Malkier leading the Malkier army on a suicide march to delay the Shadow's forces.</h3>
      <p class="c2">
        <span>
        <p>The Seven Towers bathed in flame,</p>
        <p>A king and queen bore duty's name.</p>
        <p>Their hearts could flee, their feet take flight,</p>
        <p>But honor called them to the fight.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>They held the sword, they bore the crown,</p>
        <p>They would not leave as shadows drowned.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>For Malkier, they made their stand,</p>
        <p>With trembling hearts but steady hands.</p>
        <p>They faced the dark, they faced their fate,</p>
        <p>So their son could escape the gate.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>The golden crane soared high that day,</p>
        <p>Their people’s hope, their last display.</p>
        <p>Each step they took was paved with fire,</p>
        <p>Their love burned bright, their hearts entire.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>The shadow pressed, the Blight drew near,</p>
        <p>Yet they stood firm without their fear.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>For Malkier, they made their stand,</p>
        <p>With trembling hearts but steady hands.</p>
        <p>They faced the dark, they faced their fate,</p>
        <p>So their son could escape the gate.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>A cradle’s weight, a whispered prayer,</p>
        <p>A father’s tear, a mother’s care.</p>
        <p>Go forth, our child, and carry on,</p>
        <p>For Malkier lives while you are strong.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>At Herot’s Crossing, their story ends,</p>
        <p>A king, a queen, a land defends.</p>
        <p>But through the night, their light will shine,</p>
        <p>The crown they bore, forever mine.</p>
        </span>
      </p>
    </>
  );
}
